import { createListingStepMachine } from '../../../step-machine/listingStep.machine';
import { API_CALLS } from './api';
import { CompensationFormValues } from './types';
export const compensationMachine = createListingStepMachine<CompensationFormValues>(
  API_CALLS.patch,
  'msaasListingsState',
  API_CALLS.create,
  'ON_ADD_DETAIL'
);
